import React from 'react'
import Layout from '../common/components/Layout/Layout'
import HomePage from '../modules/Home'


const Home = () => {
  return (
    <div>
      <Layout>
        <HomePage/>
      </Layout> 
     
    </div>
  )
}

export default Home